module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 007.1f148af7.jpg";